<template>
  <v-textarea
    ref="campo"
    :rows="rowsAtual"
    v-bind="$attrs"
    v-on="$listeners"
    v-model="valorInterno"
  />
</template>

<script>
export default {
  name: 'TextareaAutoRows',

  props: {
    value: {
      type: String,
      default: ''
    },
    rowsIniciais: {
      type: Number,
      default: 3
    },
    maxRows: {
      type: Number,
      default: 6
    },
    lineHeight: {
      type: Number,
      default: 30 // px
    }
  },

  data () {
    return {
      rowsAtual: this.rowsIniciais
    }
  },

  computed: {
    valorInterno: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$nextTick(this.atualizarRows)
      }
    }
  },

  mounted () {
    this.atualizarRows()
  },

  methods: {
    atualizarRows () {
      const campo = this.$refs.campo
      if (!campo) return

      const textarea = campo.$el.querySelector('textarea')
      if (!textarea) return

      // se apagou tudo, volta ao padrão
      if (!this.value || !this.value.trim()) {
        this.rowsAtual = this.rowsIniciais
        textarea.rows = this.rowsIniciais
        return
      }

      const linhas = Math.ceil(textarea.scrollHeight / this.lineHeight)

      this.rowsAtual = Math.min(
        Math.max(linhas, this.rowsIniciais),
        this.maxRows
      )

      textarea.rows = this.rowsAtual
    }
  }
}
</script>
